export default __webpack_public_path__ + "static/media/no_smoking.e62000d2.svg";